<template>
    <div>
        <card>
            <template #header>
                <h3 class="mb-0">{{ trans('activities.overview.header') }}</h3>
                <div id="activities-table-actions" />
            </template>
            <data-table
                :columns="fields"
                :items="activities"
                :no-items-view="noItemsView"
                :query-params="queryParams"
                :selection-enabled="selectionEnabled"
                pagination-container="#activities-table-actions"
                @row-clicked="showDetails"
            >
                <template #date="{ item }">
                    <td class="align-top">
                        <div class="text-muted">
                            <div class="text-nowrap">
                                {{ $filters.fullDate(item.date, currentLocale) }}
                            </div>
                            <small>
                                <icon icon="cil-clock" />
                                {{ $filters.time(item.date, currentLocale) }}</small
                            >
                        </div>
                    </td>
                </template>

                <template #causer="{ item }">
                    <td class="align-top">
                        <user-information v-if="item.causer" :info="item.causer" />
                        <span v-else>-</span>
                    </td>
                </template>

                <template #event="{ item }">
                    <td class="align-top">
                        <activity :item="item" />
                    </td>
                </template>
            </data-table>
        </card>
    </div>
</template>
<script setup>
import UserInformation from '@/Components/UserInformation.vue';
import Activity from '@/Components/ActivityLog/Activity.vue';
import DataTable from '@/Components/DataTable.vue';
import Card from '@/Components/Card.vue';
import { computed } from 'vue';
import { router } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n.js';
import { hasAnyPermission } from '@/mixins/hasAnyPermission.js';

const props = defineProps({
    activities: {
        type: [Object],
    },
    context: {
        type: String,
        required: true,
    },
    fields: {
        type: Array,
        default: () => ['date', 'causer', 'event'],
    },
    queryParams: Object,
    allowSelection: {
        type: Boolean,
        default: true,
    },
});

const noItemsView = {
    noItems: trans('activities.overview.results.empty'),
};

const selectionEnabled = computed(() => {
    return props.allowSelection && hasAnyPermission('activity.export') ? 'asset-activities' : false;
});

const showDetails = (activity) => {
    if (!activity.url) return;

    router.visit(activity.url);
};
</script>
